// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-medium-button-b0f16652","buttonLoading":"skins-medium-buttonLoading-aae2c3a8"};